import React, { useEffect, useState } from "react";
import { SoccerBall } from "@phosphor-icons/react";

/**
 * Branded "cold start" overlay. Only renders when `active` is true.
 * A hint appears after 4s so users understand what's happening on a slow wake.
 */
export const WarmupOverlay = ({ active }) => {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    if (!active) {
      setShowHint(false);
      return undefined;
    }
    const t = setTimeout(() => setShowHint(true), 4000);
    return () => clearTimeout(t);
  }, [active]);

  if (!active) return null;

  return (
    <div
      data-testid="warmup-overlay"
      className="fixed inset-0 z-[100] bg-[#090A0C]/90 backdrop-blur-sm grid place-items-center px-6"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-sm w-full text-center">
        <div className="relative inline-block">
          <SoccerBall
            size={64}
            weight="fill"
            className="text-primary-yellow animate-spin"
            style={{ animationDuration: "1.4s" }}
          />
          <div
            className="absolute -inset-3 rounded-full border border-primary-yellow/20 animate-ping"
            style={{ animationDuration: "1.6s" }}
          />
        </div>
        <div className="mt-8 text-[10px] uppercase tracking-[0.35em] text-primary-yellow font-bold">
          Warming up
        </div>
        <h2 className="font-heading text-3xl uppercase font-black mt-3 leading-tight">
          Rolling the ball<br />onto the pitch
        </h2>
        {showHint && (
          <p
            data-testid="warmup-hint"
            className="mt-6 text-xs text-white/50 leading-relaxed animate-in fade-in duration-500"
          >
            First visit in a while — the server was resting. This only happens once
            after inactivity and takes a few seconds.
          </p>
        )}
      </div>
    </div>
  );
};

export default WarmupOverlay;
